import { AspectRatio } from "../components/common/DropDowns/StaticDropdown";

export type PlaygroundVideo = {
	url: string;
};

export type VideoEditingConfigType = {
	model_id?: string;
	aspect_ratio: AspectRatio;
	fps: FPS;
	first_frame?: string;
	last_frame?: string;
	prompt: string;
};

export type VideoEditingTgConfig = {
	model_id: string;
	model_influence?: number;
	fast?: boolean;
};

export type VideoGenerationResponse = {
	url: string;
};

export const defaultVideoConfig: VideoEditingConfigType = {
	model_id: "",
	aspect_ratio: "16:9",
	fps: 16,
	prompt: "",
};

export type FPS = 16 | 24 | 30;
